/**
 * Controla el diálogo de rechazar tarea.
 */
EditTareaDialogCtrl.$inject = ['$log', '$scope'];

export default function EditTareaDialogCtrl($log, $scope) {

    if (!issetAndNotEmpty($scope.model.servicio_72h))
        $scope.model.servicio_72h = 'NO'
}